import { TablePagination } from '@mui/material';
import React from 'react';

const TablePaginationComponent = ({
  width,
  filter,
  setFilter,
  count = 0,
  getFilter,
  getVariables,
  type,
}) => {
  const page = filter?.page ?? 0;
  const limit = filter?.limit ?? 10;

  const handleChangePage = (event, newPage) => {
    setFilter({ ...filter, page: newPage }, type);
    getFilter && getFilter({ variables: { ...getVariables, limit, page: newPage + 1 } });
  };
  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setFilter({ ...filter, limit: newLimit, page: 0 }, type);
    getFilter && getFilter({ variables: { ...getVariables, limit: newLimit, page: 1 } });
  };

  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      onPageChange={handleChangePage}
      rowsPerPage={limit}
      onRowsPerPageChange={handleChangeRowsPerPage}
      rowsPerPageOptions={[10, 50, 100]}
      labelRowsPerPage={width === 'xs' || width === 'sm' ? '' : 'Rows per page:'}
    />
  );
};

export default TablePaginationComponent;
